/* eslint-disable indent */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-circular-progressbar/dist/styles.css';
import {
  HOME_COURSE_LIST_GET,
  HOME_LAST_COURSES_GET,
  HOME_NEWS_LIST_GET,
  USEFUL_LINKS_GET,
} from '../../../redux/actions/home';
import {
  HomeContainer,
  Greetings,
  CarouselHeader,
  CarouselTitle,
  AsideBlock,
  ProgressInfo,
  Ellipse,
  Progress,
  TotalCourses,
  LinksWrapper,
} from './style';
import CardCourses from '../../../../ui/atoms/Cards/CardCourses';
import routes from '../../../../routes';
import { Container } from '../../../../ui/gridSystem';
import { CTA, CircleImage, Icon, Text } from '../../../../ui/atoms';
import CardNews from '../../../../ui/atoms/Cards/CardNews';
import { DASHBOARD_INFO_GET } from '../../../redux/actions/dashboard';
import { SESSIONS_LIST_GET } from '../../../redux/actions/events';
import { DOCUMENTS_LIST_GET } from '../../../redux/actions/documents';
import CardCoursesSmall from '../../../../ui/atoms/Cards/CardCoursesSmall';
import EllipseImg from '../../../../ui/assets/img/ellipse.png';
import CardEventsSmall from '../../../../ui/atoms/Cards/CardEventsSmall';
import CardDocumentsSmall from '../../../../ui/atoms/Cards/CardDocumentsSmall';
import { CustomCarousel, DoughnutChart } from '../../../../ui/components';
import { chartConfig } from '../../../../utils/course-state';
import theme from '../../../../ui/theme';
import CardCoursesNone from '../../../../ui/atoms/Cards/CardCoursesNone';
import ModalLeaveCourse, {
  ModalLeaveCourseId,
} from '../../../../ui/atoms/Modals/ModalLeaveCourse';
import { MODAL_OPEN } from '../../../redux/actions';
import { Settings } from '../../../../ui/components/CustomCarousel/settings';
import { CarouselWrapper } from '../../../../ui/components/CustomCarousel/style';
import ModalSurvey from '../../../../ui/atoms/Modals/ModalSurvey';
import { getFilterDates } from '../../../../utils/events';
import Placeholder from '../../../../ui/atoms/Placeholder';

const options = {
  cutout: '75%',
  rotation: -90,
  circumference: 180,
  borderColor: theme().colors.aside,
};

const mandatoryOptions = {
  ...options,
  borderColor: theme().colors.transparent,
};

const HomeMobile = ({
  getLastCourses,
  recentCourses,
  getCourseList,
  courseList,
  username,
  getNews,
  news,
  getDashboardInfo,
  completion_status,
  getEventsList,
  sessions,
  getDocuments,
  documents,
  getUsefulLinks,
  usefulLinks,
  modalOpen,
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    getCourseList();
    getNews();
    getDashboardInfo();
    getLastCourses();
    getEventsList(getFilterDates());
    getDocuments();
    if (usefulLinks?.length <= 0) getUsefulLinks();
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const redirectCourseDetails = (id) => {
    navigate(`${routes.courseDetails.path}/${id}/panoramica`);
  };

  return (
    <HomeContainer>
      {/* GREETINGS */}
      <Container className="home-container">
        <Greetings>
          <CircleImage size={85} src={username?.profile_pic} name={username} />
          <div>
            <Text type="b2">
              Ciao <b>{username?.first_name || username?.username}</b>,
            </Text>
            <Text type="b2">
              benvenuto in <b>Area personale</b>
            </Text>
          </div>
        </Greetings>
      </Container>
      {/* PROGRESS */}
      <AsideBlock>
        <Text type="h2.5" mb={8}>
          I miei progressi
        </Text>
        <p>Vista generale sul tuo andamento formativo</p>
        {completion_status &&
          typeof completion_status?.completed === 'number' &&
          typeof completion_status?.incomplete === 'number' && (
            <Progress style={{ position: 'relative' }}>
              <div className="chart-wrapper">
                <DoughnutChart
                  config={
                    chartConfig({
                      total_courses:
                        completion_status.completed +
                        completion_status.incomplete,
                      in_progress: completion_status?.incomplete,
                      completed: completion_status?.completed,
                    }).config
                  }
                  customOptions={options}
                />
              </div>
              {completion_status?.mandatory > 0 && (
                <div className="chart-wrapper">
                  <DoughnutChart
                    config={
                      chartConfig({
                        total_courses:
                          completion_status.completed +
                          completion_status.incomplete,
                        mandatory: completion_status.mandatory,
                        empty:
                          completion_status.completed +
                          completion_status.incomplete -
                          completion_status.mandatory,
                      }).config
                    }
                    customOptions={mandatoryOptions}
                  />
                </div>
              )}
              <Ellipse src={EllipseImg} />
              <TotalCourses>
                <Text type="h2">
                  {completion_status.completed + completion_status.incomplete}
                </Text>
                <Text type="b3">Percorsi formativi</Text>
              </TotalCourses>
              <ProgressInfo>
                {completion_status?.mandatory > 0 && (
                  <div>
                    <Text type="h2">{completion_status?.mandatory}</Text>
                    <Text type="b5">Obbligatori</Text>
                    <div className="legend mandatory-course" />
                  </div>
                )}
                <div>
                  <Text type="h2">{completion_status?.incomplete}</Text>
                  <Text type="b5">In corso</Text>
                  <div className="legend incomplete" />
                </div>
                <div>
                  <Text type="h2">{completion_status?.completed}</Text>
                  <Text type="b5">Completati</Text>
                  <div className="legend completed" />
                </div>
              </ProgressInfo>
            </Progress>
          )}
        {recentCourses?.length > 0 ? (
          <>
            <Text type="h2.5" mb={8}>
              Continua ad apprendere
            </Text>
            <p>Hai dei corsi in sospeso, riprendi la tua formazione da qui!</p>
            {(recentCourses || []).slice(0, 3).map((c) => (
              <CardCoursesSmall
                key={`recent-${c?.id}`}
                data={c}
                onClick={() => redirectCourseDetails(c.id)}
                onClickLeave={() =>
                  modalOpen(ModalLeaveCourseId, {
                    id: c?.id,
                    title: c?.title,
                  })
                }
              />
            ))}
          </>
        ) : (
          <>
            <Text type="h2.5" mb={8}>
              Recenti
            </Text>
            <CardCoursesNone />
          </>
        )}
        {sessions?.length > 0 && (
          <>
            <Text type="h2.5" mb={8}>
              Prossimi eventi
            </Text>
            <Text type="b3" mb={24}>
              Hai degli eventi in programma per i prossimi giorni!
            </Text>
            {sessions.slice(0, 3).map((s) => (
              <CardEventsSmall
                key={`session-${s.event_id}`}
                data={s}
                onClick={() =>
                  navigate(
                    `${routes.courseDetails.path}/${s.event_id}/panoramica`
                  )
                }
              />
            ))}
          </>
        )}
        <CTA
          onClick={() => navigate(routes.dashboard.path)}
          btnText="Tutti i tuoi progressi"
          type="tertiary"
          icon="arrow-narrow-right"
          bottomRight
        />
      </AsideBlock>
      {usefulLinks?.length > 0 && (
        <AsideBlock className="secondary links">
          <Text type="h2" mb={9}>
            Link utili
          </Text>
          <LinksWrapper className="has-scrollbar">
            {usefulLinks.map((link, i) => (
              <a key={`useful-link-${i}`} href={link?.link} target="_blank">
                <Text type="h3">{link?.title}</Text>
                <Icon type="link-external-01" stroke={theme().colors.link} />
              </a>
            ))}
          </LinksWrapper>
        </AsideBlock>
      )}
      {/* COURSES */}
      <CarouselHeader>
        <CarouselTitle>
          <Text type="h1.5">Corsi principali</Text>
        </CarouselTitle>
        <CTA
          onClick={() => navigate(`${routes.catalog.path}/nazionale`)}
          btnText="Tutti i corsi"
          type="tertiary"
          icon="arrow-narrow-right"
        />
      </CarouselHeader>
      {courseList?.length > 0 ? (
        <CarouselWrapper>
          <CustomCarousel config={Settings}>
            {courseList.map((item, index) => (
              <CardCourses
                key={`traning-${index}`}
                item={item}
                onClick={() => redirectCourseDetails(item.id)}
              />
            ))}
          </CustomCarousel>
        </CarouselWrapper>
      ) : (
        <Placeholder text="Nessun percorso formativo disponibile" />
      )}
      <CarouselHeader>
        <CarouselTitle>
          <Text type="h1.5">Notizie in evidenza</Text>
        </CarouselTitle>
        <CTA
          onClick={() => navigate(routes.news.path)}
          btnText="Tutte le news"
          type="tertiary"
          icon="arrow-narrow-right"
        />
      </CarouselHeader>
      {news?.length > 0 ? (
        <CarouselWrapper>
          <CustomCarousel config={Settings}>
            {news.map((item, index) => (
              <CardNews
                key={`news-${index}`}
                item={item}
                onClick={() =>
                  navigate(`${routes.newsDetails.path}/${item?.id}`)
                }
              />
            ))}
          </CustomCarousel>
        </CarouselWrapper>
      ) : (
        <Placeholder text="Nessuna notizia disponibile" />
      )}
      {documents?.length > 0 && (
        <AsideBlock className="secondary">
          <Text type="h2" mb={24}>
            Ultimi documenti caricati
          </Text>
          {(documents || []).map((c, i) => (
            <CardDocumentsSmall
              key={`recent-${c?.id}`}
              index={i}
              data={c}
              onClick={() =>
                navigate(`${routes.documentDetails.path}/${c?.id}`)
              }
            />
          ))}
          <CTA
            onClick={() => navigate(routes.documents.path)}
            btnText="Tutti i documenti"
            type="tertiary"
            icon="arrow-narrow-right"
            bottomRight
          />
        </AsideBlock>
      )}
      <ModalLeaveCourse />
      <ModalSurvey />
    </HomeContainer>
  );
};

HomeMobile.propTypes = {
  // HOC (connect, state)
  recentCourses: PropTypes.array,
  courseList: PropTypes.array,
  username: PropTypes.object,
  news: PropTypes.array,
  completion_status: PropTypes.object,
  sessions: PropTypes.array,
  documents: PropTypes.array,
  usefulLinks: PropTypes.array,
  //HOC (connect, dispatch)
  getLastCourses: PropTypes.func.isRequired,
  getCourseList: PropTypes.func.isRequired,
  getNews: PropTypes.func,
  getDashboardInfo: PropTypes.func,
  getEventsList: PropTypes.func,
  getDocuments: PropTypes.func,
  getUsefulLinks: PropTypes.func,
  modalOpen: PropTypes.func,
};

export default connect(
  (state) => {
    const { courseList, recentCourses, news, usefulLinks } = state.home;
    const username = state.user;
    const { data: bookmarks } = state.bookmarks;
    const { modules } = state.modules;
    const { completion_status } = state.dashboard;
    const { sessions } = state.events;
    const { list: documents } = state.documents;

    return {
      recentCourses,
      courseList,
      bookmarks,
      username,
      modules,
      news,
      completion_status,
      sessions,
      documents,
      usefulLinks,
    };
  },
  (dispatch) => ({
    getLastCourses: () => dispatch({ type: HOME_LAST_COURSES_GET._REQUEST }),
    getCourseList: () => dispatch({ type: HOME_COURSE_LIST_GET._REQUEST }),
    getNews: () =>
      dispatch({
        type: HOME_NEWS_LIST_GET._REQUEST,
        filters: { how_many: 7 },
      }),
    getDashboardInfo: () => dispatch({ type: DASHBOARD_INFO_GET._REQUEST }),
    getEventsList: (filters) =>
      dispatch({ type: SESSIONS_LIST_GET._REQUEST, filters }),
    getDocuments: () =>
      dispatch({ type: DOCUMENTS_LIST_GET._REQUEST, filters: { last_doc: 3 } }),
    getUsefulLinks: () => dispatch({ type: USEFUL_LINKS_GET._REQUEST }),
    modalOpen: (id, payload = {}) =>
      dispatch({ type: MODAL_OPEN, id, payload }),
  })
)(HomeMobile);
